
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row no-gutters align="center" class="mx-2">
        <v-col class="py-0">
          <v-select
            @change="getMMRatesRpt()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.CurrencyID"
            class="mx-1"
            :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="CurrencyName"
            item-value="CurrencyID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Currency"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            @change="getMMRatesRpt()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.SellerID"
            class="mx-1"
            :items="allCounterparties.filter(a => a.IsSeller == true && a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="CounterPartyName"
            item-value="CounterPartyID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Counterparty"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.StartDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.StartDate"
                class="mx-1"
                label="Start Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getMMRatesRpt()" color="#2A353D" v-model="parameters.StartDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.StartDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="parameters.EndDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.EndDate"
                class="mx-1"
                label="End Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getMMRatesRpt()" color="#2A353D" v-model="parameters.EndDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu2 = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu2.save(parameters.EndDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-alert>

    <v-data-table
      :fixed-header="true"
      :headers="headers"
      :items="mm_rates_rpt"
      :search="search"
      :height="520"
      hide-default-footer
      disable-pagination
      @current-items="getFiltered"
      class="elevation-12 mt-2"
    >

      <template v-slot:top>
        <v-container row>
          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn @click="generatePDF(false)" text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentMMRates"
                  type    = "xls"
                  name    = "MM Trading Rates Report.xls">
    
                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </download-excel>
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentMMRates"
                  type    = "csv"
                  name    = "MM Trading Rates Report.csv">
    
                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </download-excel>
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
        </v-container>
      </template>

      <template v-slot:item.ValueDate="{ item }">
        {{ item.ValueDate | moment("YYYY-MM-DD") }}
      </template>

      <template v-slot:item.TransactionDate="{ item }">
        {{ item.TransactionDate | moment("YYYY-MM-DD") }}
      </template>

    </v-data-table>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      mm_rates_rpt: [],
      CurrentMMRates: [],
      valid: true,
      search: '',
      message: '',
      menu: false,
      loading: false,
      permitted: null,
      permitted_dialog: true,
      heading: "Money Market Rates Report",
      menu2: false,
      headers: [
        {
          text: 'Counterparty',
          sortable: false,
          value: 'Seller',
          align: 'start',
          width: 200
        },
        { text: 'Date', value: 'MMRatesDate', sortable: false, width: 130 },
        { text: '1 Day Limit', value: '1 Day Amount', sortable: false, width: 130 },
        { text: 'Value', value: '1 Day', sortable: false, width: 130 },
        { text: '7 Days Limit', value: '7 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '7 Days', sortable: false, width: 130 },
        { text: '14 Days Limit', value: '14 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '14 Days', sortable: false, width: 130 },
        { text: '21 Days Limit', value: '21 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '21 Days', sortable: false, width: 130 },
        { text: '30 Days Limit', value: '30 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '30 Days', sortable: false, width: 130 },
        { text: '60 Days Limit', value: '60 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '60 Days', sortable: false, width: 130 },
        { text: '90 Days Limit', value: '90 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '90 Days', sortable: false, width: 130 },
        { text: '120 Days Limit', value: '120 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '120 Days', sortable: false, width: 130 },
        { text: '180 Days Limit', value: '180 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '180 Days', sortable: false, width: 130 },
        { text: '270 Days Limit', value: '270 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '270 Days', sortable: false, width: 130 },
        { text: '365 Days Limit', value: '365 Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '365 Days', sortable: false, width: 130 },
        { text: '366+ Days Limit', value: '366+ Days Amount', sortable: false, width: 130 },
        { text: 'Value', value: '366+ Days', sortable: false, width: 130 },
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allCounterparties",
      "allCurrencies",
      "identity",
      "allCountries",
      "allCities",
      "currentSystemDate",
      "allClientAccounts"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    Accounts(){
      return this.allClientAccounts.filter(a => a.tblclient.CustodianID == this.parameters.CustodianID)
    }
  },

  created(){
    this.parameters = {
      CurrencyID: 1,
      SellerID: 0,
      StartDate: '2021-01-01',
      EndDate: this.currentSystemDate.DayDate
    }
    this.loading = true;
    reportsService.getMMRatesRpt(this.parameters)
    .then(response => {
      this.mm_rates_rpt = response.data;
      this.loading = false
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
      this.loading = false
    })
  },

  methods: {
    async getMMRatesRpt() {
      if(this.parameters.CurrencyID == null || this.parameters.CurrencyID == ''){
        this.parameters.CurrencyID = 0
      }
      if(this.parameters.SellerID == null || this.parameters.SellerID == ''){
        this.parameters.SellerID = 0
      }
      if (this.parameters.StartDate != null && this.parameters.EndDate != null) {
        this.loading = true;
        reportsService.getMMRatesRpt(this.parameters)
        .then(response => {
          this.mm_rates_rpt = response.data;
          this.loading = false
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false
        })
      }
    },
    generatePDF(IsPrint) {
      const columns = [
        { title: 'Countertparty', dataKey: 'Seller' },
        { title: 'Date', dataKey: 'MMRatesDate' },
        { title: '1-Day-Limit', dataKey: '1 Day Amount' },
        { title: 'Value', dataKey: '1 Day' },
        { title: '7-Days-Limit', dataKey: '7 Days Amount' },
        { title: 'Value', dataKey: '7 Days' },
        { title: '14-Days-Limit', dataKey: '14 Days Amount' },
        { title: 'Value', dataKey: '14 Days' },
        { title: '21-Days-Limit', dataKey: '21 Days Amount' },
        { title: 'Value', dataKey: '21 Days' },
        { title: '30-Days-Limit', dataKey: '30 Days Amount' },
        { title: 'Value', dataKey: '30 Days' },
        { title: '60-Days-Limit', dataKey: '60 Days Amount' },
        { title: 'Value', dataKey: '60 Days' },
        { title: '90-Days-Limit', dataKey: '90 Days Amount' },
        { title: 'Value', dataKey: '90 Days' },
        { title: '120-Days-Limit', dataKey: '120 Days Amount' },
        { title: 'Value', dataKey: '120 Days' },
        { title: '180-Days-Limit', dataKey: '180 Days Amount' },
        { title: 'Value', dataKey: '180 Days' },
        { title: '270-Days-Limit', dataKey: '270 Days Amount' },
        { title: 'Value', dataKey: '270 Days' },
        { title: '365-Days-Limit', dataKey: '365 Days Amount' },
        { title: 'Value', dataKey: '365 Days' },
        { title: '366+-Days-Limit', dataKey: '366+ Days Amount' },
        { title: 'Value', dataKey: '366+ Days' },
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 8.5, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 8.5, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 8.5, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 8.5, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 8.5, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 8.5, 1.0);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          doc.setFontSize(8).text((this.parameters.CurrencyID > 0? 'Currency: ' + this.allCurrencies.filter(a => a.CurrencyID == this.parameters.CurrencyID).map(a => a.CurrencyName) + '        ' : '') + (this.parameters.SellerID > 0? 'Counterparty: ' + this.allCounterparties.filter(a => a.CounterpartyID == this.parameters.SellerID).map(a => a.CounterpartyName) : ''), 0.5, 1.4);
          // create a line under heading
          doc.setLineWidth(0.01).line(0.5, 1.5, 10.5, 1.5);
          doc.setLineWidth(0.01).line(0.5, 1.7, 10.5, 1.7);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        columns,
        body: this.CurrentMMRates,
        margin: { left: 0.5, top: 1.5 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('MM Trading Rates Report.pdf')
      }
    },
    getFiltered(current){
      this.CurrentMMRates = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>